exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#v-scroll {\n    overflow: auto;\n    max-height: 500px;\n}\n\n#v-scroll th {\n    position: sticky;\n    top: 0;\n}\n\n/*\n.MuiTypography-body1 {\n    font-size: 2rem !important;\n}\n*/\n.fa-star-o:before {\n    font-size: 2rem !important;\n}\n.MuiListItemText-inset {\n    padding-left: 20px !important;\n}", ""]);

// exports
